import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getMonitorList} from '@apis'
import MonitorItem from '@components/monitorItem'
import './index.less'

// 灯光秀控制
const RealtimeMonitor = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [monitorList, setMonitorList] = useState([])
    const [curLeftIndex, setCurLeftIndex] = useState()
    const [monitorUrl, setMonitorUrl] = useState()

    async function queryMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
        if(res.data[0]) {
          setCurLeftIndex(res.data[0].monitorAccessToken)
          setMonitorUrl(res.data[0].url)
        }
      }
    }

    useEffect(() => {
      queryMonitorList()
    }, [])

    return (
      <React.Fragment>
        <div className="realtime-show-left">
          {monitorList.length ? (
            <MonitorItem
              url={monitorUrl}
              accessToken={curLeftIndex}
            />
          ) : null}
        </div>
        <div className="realtime-show-right">
          <div className="program-list clearfix">
            {
              monitorList.map(item => (
                <div className="program-item-box">
                  <MonitorItem
                    url={item.url}
                    accessToken={item.monitorAccessToken}
                  />
                  <div className="program-title">
                    {item.name}
                    {
                      monitorUrl === item.url ? (
                        <span className="program-span"> : 正在展示中</span>)
                        : null
                    }
                  </div>
                  <div
                    className="program-div"
                    onDoubleClick={() => {
                      setMonitorUrl(item.url)
                      setCurLeftIndex(item.monitorAccessToken)
                    }}
                  >
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </React.Fragment>
    )
  })
)

export default RealtimeMonitor
